<template>
  <div class="banner-grid">
    <h2 class="banner-title">
      {{ moduleData.name }}
    </h2>

    <BannerModuleImage
      :module-data="moduleData"
      :banner-class="bannerClass" />

    <template v-if="!isLoading">
      <div
        v-for="offer in productsData"
        :key="offer.id"
        class="offer-item">
        <ProductCard
          :product="offer"
          :is-game-banner="true" />
      </div>
    </template>

    <template v-else>
      <div
        v-for="n in moduleData.offers.length"
        :key="n"
        class="offer-item skeleton">
        <SkeletonProductCard :force-mobile-view="true" />
      </div>
    </template>
  </div>
</template>

<script>
import ProductCard from 'Root/pages/game/components/ProductCard.vue';
import BannerModuleImage from 'Root/components/Catalog/BannerModuleImage.vue';
import SkeletonProductCard from './SkeletonProductCard.vue';

export default {
  name: 'BannerModule',

  components: {
    ProductCard,
    BannerModuleImage,
    SkeletonProductCard,
  },

  props: {
    productsData: {
      type: Array,
      default: () => [],
    },

    moduleData: {
      type: Object,
      required: true,
    },

    isLoading: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    bannerClass() {
      if (this.moduleData.offers.length === 0) {
        return 'banner-three-cols';
      }

      if (this.moduleData.offers.length <= 3) {
        return 'banner-two-cols';
      }

      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-grid {
  display: grid;
  grid-template-columns: 1fr repeat(2, minmax(0, 267px));
  grid-template-rows: auto repeat(3, 127px);
  gap: 16px;
  grid-auto-flow: column;

  /deep/.card__title {
    font-size: 15px;
    padding-bottom: 0;
  }

  /deep/.card__subscription {
    display: none;
  }

  /deep/.card__head-content {
    grid-template-rows: 1fr 60px 1fr;
  }

  /deep/.card__order {
    padding-top: 8px;
  }
}

.banner-title {
  color: $color--basic-white;
  font-size: 25px;
  margin-bottom: 8px;
  font-weight: 500;
  grid-row: 1 / 2;
  grid-column: 1 / -1;
}

.offer-item {
  grid-column: span 1;
}

@media screen and #{$screen-less-than-1024} {
  .banner-grid {
    grid-template-columns: 1fr minmax(0, 267px);

    .offer-item:nth-child(n+6) {
      display: none;
    }
  }
}

@media screen and #{$screen-less-than-768} {
  .banner-grid {
    grid-template-columns: 1fr;
    grid-template-rows: auto 178px;
  }

  .offer-item {
    display: none;
  }
}

@media screen and #{$screen-less-than-480} {
  .banner-grid {
    grid-template-rows: auto minmax(120px, 1fr);
    grid-auto-rows: 100px;
    gap: 16px;
    grid-auto-flow: row;

    .offer-item {
      display: block;
    }

    .offer-item:nth-child(n + 4):nth-child(-n + 6) {
      display: block;
    }
  }
}
</style>
